module.exports = __webpack_public_path__ + "static/media/1.dfc54362.png";